import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiUser, FiMenu, FiLogOut } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';
import useRequest from '../../hooks/useRequest';

function DashboardTopbar({ setIsSidebarOpen, isSidebarOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const { sendRequest } = useRequest();

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  const getTitle = (path) => {
    switch (path) {
      // case '/dashboard/find-groups':
      //   return 'Find Groups';
      case '/dashboard/group-list':
        return 'My Groups';
      case '/dashboard/support':
        return 'Support';
      case '/dashboard/broker':
        return 'Broker List';
      default:
        return 'Dashboard';
    }
  };

  const handleLogout = async () => {
    try {
      await sendRequest('POST', '/customer/logout/');
      // Clear all stored data
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userData');
      // Redirect to login
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="bg-white shadow-sm border-b border-gray-100">
      <div className="px-6 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {!isSidebarOpen && (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setIsSidebarOpen(true)}
              className="p-2 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <FiMenu className="w-6 h-6 text-gray-600" />
            </motion.button>
          )}
          <motion.h1 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-xl font-semibold text-gray-800"
          >
            {getTitle(location.pathname)}
          </motion.h1>
        </div>

        <div className="flex items-center space-x-6">
          <div 
            className="relative group"
            onMouseEnter={() => setIsProfileOpen(true)}
            onMouseLeave={() => setIsProfileOpen(false)}
          >
            <motion.div 
              whileHover={{ scale: 1.02 }}
              className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#C334F6] to-[#543DF4] flex items-center justify-center text-white shadow-sm">
                <FiUser className="w-5 h-5" />
              </div>
              <div>
                <div className="text-sm font-medium text-gray-800">{userData?.name || 'User'}</div>
                <div className="text-xs text-gray-500">{userData?.email || 'user@example.com'}</div>
              </div>
            </motion.div>

            <AnimatePresence>
              {isProfileOpen && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.2 }}
                  className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 z-50 border border-gray-100"
                >
                  <div className="px-4 py-2 border-b border-gray-100">
                    <div className="text-sm font-medium text-gray-800">{userData?.name || 'User'}</div>
                    <div className="text-xs text-gray-500">{userData?.email || 'user@example.com'}</div>
                  </div>
                  <div className="py-1">
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                      <FiLogOut className="w-4 h-4 mr-2" />
                      Logout
                    </button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardTopbar; 